import { Box, Button, Grid,Stack, TextField, Typography,Snackbar,Alert } from '@mui/material'
import styles from './index.module.css'
import React, { useEffect, useState } from 'react'
import emailjs from '@emailjs/browser';
import { BreadcrumbContext } from '../../components/Breadcrumb';
import useBreadcrumb from '../../hooks/useBreadcrumb';
import chaticon from '../../assets/icons/Bck/chaticon.png'
import locationicon from '../../assets/icons/Bck/locationicon.png'
import phoneicon from '../../assets/icons/Bck/phoneicon.png'
import mailicon from '../../assets/icons/Bck/mailicon.png'

function Contact() {
    const { setBreadcrumb, clearBreadcrumb } = useBreadcrumb();

    useEffect(() => {
        setBreadcrumb({ title: "Contact", links: [{ title: "Home", url: "/" }, { title: "Contact" }] })

        return clearBreadcrumb;
    }, []);

    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        message: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        let newValue = value;

        if (name === 'name') {
            newValue = value.replace(/[^A-Za-z ]/g, '').slice(0, 20);
        }

        if (name === 'phone') {
            newValue = value
                .replace(/[^0-9+]/g, '')
                .replace(/(?!^)\+/g, '')
                .slice(0, 16);
        }

        if (name === 'message') {
            newValue = value.slice(0, 200);
        }

        setFormData({
            ...formData,
            [name]: newValue
        });

        setErrors({
            ...errors,
            [name]: ''
        });
    };

    const sendEmail = (e) => {
        e.preventDefault();

        const isValid = validate();

        if (!isValid) {
            setSnackbar({
                open: true,
                message: 'Please fill in all required fields.',
                severity: 'error'
            });
            return;
        }

        setLoading(true);

        emailjs.send(
            'service_iptisgs',
            'template_6z0v4pi',
            {
                from_name: formData.name,
                phone: formData.phone,
                message: formData.message,
            },
            'rkcVn9dtWJ0NquW4h'
        ).then(
            () => {
                setSnackbar({
                    open: true,
                    message: 'Message sent successfully!',
                    severity: 'success'
                });
                setFormData({ name: '', phone: '', message: '' });
                setErrors({});
                setLoading(false);
            },
            (error) => {
                console.error(error);
                setSnackbar({
                    open: true,
                    message: 'Failed to send message',
                    severity: 'error'
                });
                setLoading(false);
            }
        );
    };
    const [errors, setErrors] = useState({});
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success'
    });

    const validate = () => {
        let tempErrors = {};

        // Name
        if (!formData.name.trim()) {
            tempErrors.name = 'Full Name is required';
        } else if (!/^[A-Za-z ]+$/.test(formData.name)) {
            tempErrors.name = 'Only letters allowed';
        } else if (formData.name.length > 20) {
            tempErrors.name = 'Max 20 characters allowed';
        }

        // Phone
        if (!formData.phone.trim()) {
            tempErrors.phone = 'Phone number is required';
        }
        else if (!/^\+?[1-9]\d{6,14}$/.test(formData.phone)) {
            tempErrors.phone = 'Enter a valid phone number (include country code if needed)';
        }

        // Message
        if (!formData.message.trim()) {
            tempErrors.message = 'Message is required';
        } else if (formData.message.length > 200) {
            tempErrors.message = 'Max 200 characters allowed';
        }

        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const [loading, setLoading] = useState(false);
    return (
        <Box className={styles.container} sx={{
            p: {
                xs: 4,
                sm: 6,
                md: 8,
                lg: 12,
                xl: 15
            }
        }}>
            <Typography variant='h4' sx={{ color: '#0a9a73', mb: 2 }}>Contact Us</Typography>
            <Typography variant='body1' sx={{ mb: 4 }}>
                Get in Touch with Us 
            </Typography>

            <Grid container spacing={4}>
                <Grid item xs={12} md={4}>
                    <Stack spacing={3}>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: '#fff',
                            borderRadius: '2rem',
                            // p: 2,
                        }}>
                            <Box sx={{
                                backgroundColor: '#0a9a73',
                                borderRadius: '50%',
                                p: 1.5,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mr: 2,
                                width: 48,
                                height: 48,
                            }}>
                                <img src={phoneicon} alt="Phone" width={75} height={75} />
                            </Box>
                            <Box>
                                <Typography variant="subtitle2" sx={{ fontWeight: 700, fontSize: '1.05rem' }}>Phone Number:</Typography>
                                <Typography variant="body2" sx={{  fontSize: '1rem' }}>Head office:(774) 765 1616</Typography>
                            </Box>
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: '#fff',
                            borderRadius: '2rem',
                            // p: 2,
                        }}>
                            <Box sx={{
                                backgroundColor: '#0a9a73',
                                borderRadius: '50%',
                                p: 1.5,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mr: 2,
                                width: 48,
                                height: 48,
                            }}>
                                <img src={mailicon} alt="Mail" width={75} height={75} />
                            </Box>
                            <Box>
                                <Typography variant="subtitle2" sx={{ fontWeight: 700, fontSize: '1.05rem' }}>Mail Address:</Typography>
                                <Typography variant="body2" sx={{  fontSize: '1rem' }}>ravi@mysavcare.com</Typography>
                            </Box>
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: '#fff',
                            borderRadius: '2rem',
                            // p: 2,
                        }}>
                            <Box sx={{
                                backgroundColor: '#0a9a73',
                                borderRadius: '50%',
                                p: 1.5,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mr: 2,
                                width: 48,
                                height: 48,
                            }}>
                                <img src={locationicon} alt="Location" width={75} height={75} />
                            </Box>
                            <Box>
                                <Typography variant="subtitle2" sx={{ fontWeight: 700, fontSize: '1.05rem' }}>Office Address:</Typography>
                                <Typography variant="body2" sx={{  fontSize: '1rem' }}>15 Payson Road, Foxboro 02035 MA</Typography>
                            </Box>
                        </Box>
                         <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            backgroundColor: '#fff',
                            borderRadius: '2rem',
                            // p: 2,
                        }}>
                            <Box sx={{
                                backgroundColor: '#0a9a73',
                                borderRadius: '50%',
                                p: 1.5,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mr: 2,
                                width: 48,
                                height: 48,
                            }}>
                                <img src={chaticon} alt="Location" width={75} height={75} />
                            </Box>
                            <Box>
                                <Typography variant="subtitle2" sx={{ fontWeight: 700, fontSize: '1.05rem' }}>Text Number:</Typography>
                                <Typography variant="body2" sx={{  fontSize: '1rem' }}>774 228 7069</Typography>
                            </Box>
                        </Box>
                    </Stack>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Box
                        sx={{
                            height: '100%',
                            minHeight: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                        }}
                    >
                        <Box sx={{
                            borderRadius: '12px',
                            overflow: 'hidden',
                            flexGrow: 1,
                            minHeight: '300px',
                            boxShadow: 1,
                        }}>
                            <iframe
                                title="Google Map"
                                width="100%"
                                height="100%"
                                style={{ border: 0 }}
                                loading="lazy"
                                allowFullScreen
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2961.445940606852!2d-71.259056724807!3d42.076494052970794!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e4630afa512fd7%3A0x8d00ac5aca2eafbf!2sSavCare%20Pharmacy!5e0!3m2!1sen!2sus!4v1763971508839!5m2!1sen!2sus"
                            />
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Stack spacing={2}>
                        <Stack spacing={1}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, fontSize: '1.05rem' }}>Full Name *</Typography>
                            <TextField size="small"  name="name" value={formData.name} onChange={handleChange} error={!!errors.name} helperText={errors.name}/>
                        </Stack>
                        <Stack spacing={1}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, fontSize: '1.05rem' }}>Phone Number *</Typography>
                            <TextField size="small"  name="phone" value={formData.phone} onChange={handleChange} error={!!errors.phone} helperText={errors.phone}/>
                        </Stack>
                        <Stack spacing={1}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700, fontSize: '1.05rem' }}>Message *</Typography>
                            <TextField multiline rows={3}  name="message" value={formData.message} onChange={handleChange} error={!!errors.message} helperText={errors.message}/>
                        </Stack>
                        <Typography variant='body2' sx={{fontWeight:500}}>* Required Information</Typography>
                        <Button className={styles.info} variant="contained" onClick={sendEmail} disabled={loading}> {loading ? 'Sending...' : 'Send Message'} </Button>
                    </Stack>
                </Grid>
            </Grid>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert
                    severity={snackbar.severity}
                    onClose={() => setSnackbar({ ...snackbar, open: false })}
                    sx={{ width: '100%' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Box>
    );
}

export default Contact
